<template>
    <v-container class="grey lighten-5" fluid>

        <div v-if="showNiPos">
            <v-card style="margin-top: 1em;">
                <v-tabs
                color="primary"
                centered
                >
                    <v-tab
                    v-if="![7, 8, 9].includes($store.state.user.user_role.id)"
                    >ECOM</v-tab>
                    <v-tab>POS</v-tab>

                    <v-tab-item
                    :key="1"
                    :transition="false"
                    v-if="![7, 8, 9].includes($store.state.user.user_role.id)"
                    >
                        <v-card-text>
                            <!-- God Mode, Administrator, Manager -->
                            <management v-if="$store.state.user.user_role.id <= 3"></management>

                            <!-- Superuser, User High, Medium -->
                            <client v-else-if="$store.state.user.user_role.id > 3 && $store.state.user.user_role.id < 7"></client>

                            <!-- User Low -->
                            <simple v-else-if="[7, 8, 9].includes($store.state.user.user_role.id)"></simple> 
                        </v-card-text>
                    </v-tab-item>

                    <v-tab-item
                    :key="2"
                    :transition="false"
                    >                                
                        <v-card-text>
                            <ni-pos></ni-pos>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </div>

        <div v-else>
            <!-- God Mode, Administrator, Manager -->
            <management v-if="$store.state.user.user_role.id <= 3"></management>

            <!-- Superuser, User High, Medium -->
            <client v-else-if="$store.state.user.user_role.id > 3 && $store.state.user.user_role.id < 7"></client>

            <!-- User Low -->
            <simple v-else-if="[7, 8, 9].includes($store.state.user.user_role.id)"></simple> 
        </div>
    </v-container>
</template>

<script>
import Management from '../components/dashboards/Management.vue';
import Client from '../components/dashboards/Client.vue';
import Simple from '../components/dashboards/Simple.vue';
import NiPos from '../components/dashboards/NiPos.vue'

export default {
    components: {
        'client': Client,
        'management': Management,
        'simple': Simple,
        'niPos': NiPos,
    },
    data() {
        return {
            showNiPos: false,
        }
    },
    methods: {
        checkPosAccess() {
            var posAccess = this.$store.state.user.ni_pos_merchant_id;
            var parsedAccess = JSON.parse(posAccess);
            if (!(parsedAccess === undefined || parsedAccess === null)) {
                if (parsedAccess.length > 0) {
                    this.showNiPos = true;
                }
            }
        }
    },
    beforeMount() {
        this.checkPosAccess();
    },
}
</script>